module.exports = __webpack_public_path__ + "static/media/icon-activity.3ca4ea89.svg";